export const isNumberOrDecimal = (value: string): boolean => {
  let RegExp = /^\d*\.?\d*$/;

  return RegExp.test(value);
};
